import { ThemeProvider } from '@mui/system';
import { Component } from 'react';
import { Redirect, Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { jaliaTheme, popinaTheme } from './utils/theme';

import AuthenticationContainer from "./view/Authentication/AuthenticationContainer";
import HomeContainer from "./view/Home/HomeContainer";

import AuthenticationActionCreator from "./controller/action/AuthenticationActionCreator";
import AppStore from "./controller/store/AppStore";
import Environment from './utils/Environement';
import LoadingContainer from "./view/LoadingContainer";
import LoadingComponent from './view/utils/LoadingComponent';

interface AppStateInterface {
  reload: boolean,
  isReady: boolean
}

const defaultState: AppStateInterface = {
  reload: false,
  isReady: false
};

class App extends Component {

  public state: AppStateInterface

  constructor(props: any) {
    super(props);
    this.state = defaultState;
    this._onStateChange = this._onStateChange.bind(this);
  }

  _onStateChange() {
    this.setState({ reload: !this.state.reload });
  }

  checkIfEstablishmentAlreadyLogged = async () => {
    try{
      await AuthenticationActionCreator.checkIfEstablishmentAlreadyLogged();
    }catch(err){}
    finally{
      this.setState({isReady:true});
    }
  }

  componentDidMount() {
    let link = document.querySelector("link[rel='icon']") as HTMLLinkElement;
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    if (Environment.isPopina) {
      link.href = "/assets/favico-popina/favicon.ico";
    } else {
      link.href = "/assets/favico-jalia/favicon.ico";
    }
    AppStore.addChangeListener(this._onStateChange);
    this.checkIfEstablishmentAlreadyLogged();
  }

  componentWillUnmount() {
    AppStore.removeChangeListener(this._onStateChange);
  }

  render() {
    return (!this.state.isReady ? <LoadingComponent isOpen={!this.state.isReady} /> :
      <ThemeProvider theme={(Environment.isPopina) ? popinaTheme() : jaliaTheme()}>
        <Router>
          <Switch>
            <Route
              path="/home"
              render={(history) => AppStore.isAuthenticated
                ? <HomeContainer {...history} establishment={AppStore.establishment} />
                : <Redirect to="/login" />
              }
            />
            <Route
              path="/login"
              render={(history) => AppStore.isAuthenticated
                ? <Redirect to="/home" />
                : <AuthenticationContainer {...history} />
              }
            />
            <Route
              path="/ipad/:token/:restaurantID/:name/:locationId"
              render={(history) => {
                const data = (history.match).params as any;
                const locationId = data['locationId'];
                const token = data['token'];
                const restaurantID = data['restaurantID'];
                const name = data['name'];

                if (locationId === undefined || token === undefined || restaurantID === undefined || name === locationId) {
                  return <Redirect to="/login" />
                }

                return <LoadingContainer
                  {...history}
                  token={token}
                  restaurantID={restaurantID}
                  locationId={locationId}
                  name={name}
                />
              }}
            />
            <Route
            path="/"
            render={() => AppStore.isAuthenticated
              ? <Redirect to="/home" />
              : <Redirect to="/login" />
            }
          />
          </Switch>
        </Router>
      </ThemeProvider>
    )
  }
}

export default App;